module.exports = __webpack_public_path__ + "img/non_favorite.e3924f40.png";